import { useBoolean } from '@dreryk/react-common';

import { PreInterviewCreateModal } from './PreInterviewCreateModal';

type PreInterviewCreateModalOpenerRenderProps = { openModal: VoidFunction };
type PreInterviewCreateModalOpenerProps = {
   readonly appointmentId: number;
   readonly beginDate: Date;
   readonly children: (renderProps: PreInterviewCreateModalOpenerRenderProps) => JSX.Element;
   readonly endDate: Date;
   readonly patientFullName: string;
};

export const PreInterviewCreateModalOpener = (props: PreInterviewCreateModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <PreInterviewCreateModal
               appointmentId={props.appointmentId}
               beginDate={props.beginDate}
               endDate={props.endDate}
               onClose={closeModal}
               patientFullName={props.patientFullName}
            />
         ) : null}
      </>
   );
};
